import { EditOrdreFabricationPage } from "@features/production/components/EditOrdreFabricationPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { FileEdit } from "lucide-react";

export const Route = createFileRoute("/_app/production/ordres-fabrication/$id/edit")({
  loader: requirePermission(PERMISSIONS.PRODUCTION.OF.EDIT),
  staticData: {
    title: "Modifier OF",
    icon: FileEdit,
    permission: PERMISSIONS.PRODUCTION.OF.EDIT,
    section: "App",
    showInBreadcrumb: true,
  },
  component: EditOrdreFabricationPage,
});
